import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PageProdutoComponent } from './pages/page-produto/page-produto.component';
import { SimpleHtmlModule } from 'src/app/components/simple-html/simple-html.module';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from 'src/app/app.routes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectiveModule } from 'src/app/directive/directives.module';
import { SliderProdutoComponent } from './components/slider-produto/slider-produto.component';
import {MatSelectModule} from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
@NgModule({
  declarations: [
    PageProdutoComponent,
    SliderProdutoComponent
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    AppRoutingModule,
    FormsModule,
    SimpleHtmlModule,
    BrowserModule,
    ReactiveFormsModule,
    MatIconModule,
    DirectiveModule
  ],
  exports: [
    PageProdutoComponent,
    SliderProdutoComponent
  ]
})
export class ProductModule { }
